// extracted by mini-css-extract-plugin
export var imageWrapper = "brand-card-module--imageWrapper--87c50";
export var info = "brand-card-module--info--57d3e";
export var storeLink = "brand-card-module--storeLink--00339";
export var wrapper = "brand-card-module--wrapper--a64d6";